import makeX1DarkModeStateProvider from "./makeX1DarkModeStateProvider";
import { X1DarkMode } from "./X1DarkMode";

export const X1DarkModeStateProvider = makeX1DarkModeStateProvider({
  getDarkModeSetting: X1DarkMode.getDarkModeSetting,
  saveDarkModeSetting: X1DarkMode.saveDarkModeSetting,
});
